import styles from './TrophyDetail.module.scss'
import { TrophyDetailCard } from '~/components/TrophyDetailCard/TrophyDetailCard'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { TrophyDetailComponentDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import { BackLink } from '~/components/BackLink'

interface Props {
  trophyDetailDto: TrophyDetailComponentDto
  backlink?: boolean
}

export const TrophyDetail: FC<Props> = ({ trophyDetailDto, backlink }) => {
  const { t } = useTranslation('trophy_details')

  return (
    <section className={ styles.trophyDetail__container }>
      { backlink && <BackLink/> }

      <h1 className={ styles.trophyDetail__title }>
        { t('trophy_detail_title') }
      </h1>

      <TrophyDetailCard
        trophyDetailDto={ trophyDetailDto }
        key={ trophyDetailDto.id?.toString() }
      />
    </section>
  )
}
